var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"pb-4 d-flex justify-space-between"},[_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-btn',{staticClass:"pr-0",attrs:{"min-width":"20","color":"lightGrey","plain":"","small":"","ripple":false},on:{"click":_vm.close}},[_c('v-icon',{staticClass:"uikit-icon close size-20"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }